import { Tooltip } from "@fluentui/react-components";
import { useRef, useState } from "react";
import { IOverflowTooltipProps } from "./overflowTooltip.types";

export const OverflowTooltip = ({
  text,
  overflowSelector,
  children,
}: IOverflowTooltipProps): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = (): void => {
    const container = containerRef.current;
    const target = overflowSelector
      ? container?.querySelector<HTMLElement>(overflowSelector)
      : container;
    if (
      target &&
      (target.scrollWidth > target.clientWidth ||
        target.scrollHeight > target.clientHeight)
    ) {
      setIsVisible(true);
    }
  };

  return (
    <Tooltip
      content={text}
      relationship="description"
      appearance="inverted"
      positioning="above-start"
      withArrow
      visible={isVisible && !!text}
    >
      <div
        ref={containerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
    </Tooltip>
  );
};
